// extracted by mini-css-extract-plugin
export var borderRadius = "_bc-4";
export var large = "_bc-3";
export var logoContainer = "_bc-0";
export var nameLogo = "_bc-2";
export var small = "_bc-1";